let CURRENT_ORD = 0;
export class EdgeBase {
    type;
    dep;
    ord;
    updatedAt;
    consumedAt;
    nextDirty;
    constructor(type, dep, updatedAt, consumedAt) {
        this.type = type;
        this.dep = dep;
        this.ord = CURRENT_ORD++;
        this.updatedAt = updatedAt;
        this.consumedAt = consumedAt;
        this.nextDirty = undefined;
    }
}
export function createEdge(prevEdge, type, dep, updatedAt, consumedAt) {
    if (prevEdge === undefined) {
        return new EdgeBase(type, dep, updatedAt, consumedAt);
    }
    prevEdge.ord = CURRENT_ORD++;
    prevEdge.updatedAt = updatedAt;
    prevEdge.consumedAt = consumedAt;
    prevEdge.nextDirty = undefined;
    return prevEdge;
}
export function findAndRemoveDirty(sub, dep) {
    let edge = sub.dirtyHead;
    if (edge === undefined) {
        return undefined;
    }
    if (edge.dep === dep) {
        sub.dirtyHead = edge.nextDirty;
        return edge;
    }
    let nextLink = edge.nextDirty;
    while (nextLink !== undefined) {
        if (nextLink.dep === dep) {
            edge.nextDirty = nextLink.nextDirty;
            return nextLink;
        }
        edge = nextLink;
        nextLink = edge.nextDirty;
    }
    return undefined;
}
